import React from 'react';

import styled from '@emotion/styled';

import { colors } from '../../global';
import { media } from '../../services/media';
import { Calculator } from './components/Calculator';
import { Logo } from './components/Logo';
import { OfferContext } from './context';
import { OfferContent } from './OfferContent';
import { OfferForm } from './OfferForm';

export const Offer = ({ offer, index, separator }: any) => {
    if (!offer || !offer.content) return null;

    return (
        <OfferContext.Provider value={{ slug: offer.slug, ...offer.content }}>
            <StyledOffer>
                <Logo />
                <div className="Offer__content">
                    <OfferContent />
                    <OfferForm />
                    <Calculator />
                </div>
                {separator && <Separator />}
            </StyledOffer>
        </OfferContext.Provider>
    );
};

const StyledOffer = styled.div`
    position: relative;

    &:first-of-type {
        padding-top: 60px;
    }

    ${media.min('lg')} {
        &:first-of-type {
            padding-top: 0;
        }
    }

    /** Third party package */
    .trustpilot-widget {
        text-align: center;

        a {
            display: none;
        }

        ${media.min('lg')} {
            position: absolute !important;
            top: 20px;
            right: 40px;
        }
    }
`;

const Separator = styled.div`
    width: 100%;
    height: 10px;
    background-color: ${colors.alto};
`;
